import React, { PropsWithChildren } from 'react';
import { NavItem, Button, Row, Badge } from 'reactstrap';
import { WizardStepProp } from '..';

import './index.css';
import Loader from 'react-loaders';

const StepBadge = ({
  badge,
  complete,
}: {
  badge?: string;
  complete?: boolean;
}) => (
  <Badge color="light" className="mr-1">
    {complete ? '✓' : badge || '-'}
  </Badge>
);

const DefaultWizardStep = ({
  active,
  loading,
  disabled,
  title,
  badge,
  subTitle,
  complete,
  onClick = () => {},
}: WizardStepProp) => (
  <NavItem>
    {loading ? (
      <div className="wizard-loading d-flex align-items-center">
        <div className="m-auto">
          <Loader active type="line-scale-pulse-out" />
        </div>
      </div>
    ) : (
      <Button
        tag="label"
        block
        color={disabled ? 'secondary' : complete ? 'success' : 'primary'}
        active={!disabled && active}
        disabled={disabled}
        onClick={() => onClick()}
        className="wizard-btn text-left mb-0 round-0 max-vh-22">
        <div className="w-100">
          {<StepBadge badge={badge} complete={complete} />}
          {title}
        </div>
        {subTitle ? <small className="pl-4">{subTitle}</small> : null}
      </Button>
    )}
  </NavItem>
);

const ExpendableWizardStep = ({
  active,
  disabled,
  title,
  children,
  complete,
  subTitle,
  badge,
  onClick = () => {},
}: PropsWithChildren<WizardStepProp>) => {
  return (
    <>
      <NavItem>
        <Button
          tag="label"
          block
          color={disabled ? 'secondary' : complete ? 'success' : 'primary'}
          active={!disabled && active}
          disabled={disabled}
          onClick={() => {
            onClick();
          }}
          className="wizard-btn text-left mb-0 round-0 max-vh-22">
          <div className="w-100">
            {<StepBadge badge={badge} complete={complete} />}
            {title}
          </div>
          {subTitle ? <small className="pl-4">{subTitle}</small> : null}
        </Button>
      </NavItem>
      <Row noGutters className="w-100 order-last" hidden={!active}>
        {children}
      </Row>
    </>
  );
};

const WizardStep = ({ children, ...rest }: PropsWithChildren<WizardStepProp>) =>
  children ? (
    <ExpendableWizardStep children={children} {...rest} />
  ) : (
    <DefaultWizardStep {...rest} />
  );

export default WizardStep;
